const { REACT_APP_IPFS_GATEWAY } = process.env;

const ipfsToHttp = (url: string) => {
  return url.replace('ipfs://', `${REACT_APP_IPFS_GATEWAY}/`);
};

export { ipfsToHttp };
